import React, { useEffect, useMemo } from "react";
import SmartifyReport from "../../../components/mailReports/SmartifyReport";

const ReportSmartifyDaily = () => {
  return <SmartifyReport type="daily" />;
};

export default ReportSmartifyDaily;
